import { render } from "./PlaceData.vue?vue&type=template&id=e6cce998&scoped=true"
import script from "./PlaceData.vue?vue&type=script&lang=js"
export * from "./PlaceData.vue?vue&type=script&lang=js"

import "./PlaceData.vue?vue&type=style&index=0&id=e6cce998&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6cce998"]])

export default __exports__